import Roles from 'src/security/roles';
import Plans from 'src/security/plans';
import Storage from 'src/security/storage';

const storage = Storage.values;
const roles = Roles.values;
const plans = Plans.values;

class Permissions {
  static get values() {
    return {
      tenantEdit: {
        id: 'tenantEdit',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantDestroy: {
        id: 'tenantDestroy',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantCreate: {
        id: 'tenantCreate',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planEdit: {
        id: 'planEdit',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planRead: {
        id: 'planRead',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userEdit: {
        id: 'userEdit',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userDestroy: {
        id: 'userDestroy',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userCreate: {
        id: 'userCreate',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userImport: {
        id: 'userImport',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userRead: {
        id: 'userRead',
        allowedRoles: [roles.admin, roles.local],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userAutocomplete: {
        id: 'userAutocomplete',
        allowedRoles: [roles.admin, roles.local],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      auditLogRead: {
        id: 'auditLogRead',
        allowedRoles: [roles.admin],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      settingsEdit: {
        id: 'settingsEdit',
        allowedRoles: [roles.admin, roles.local],
         allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.settingsBackgroundImages,
          storage.settingsLogos,
          storage.settingsBannerLogos,
        ],
      },
      eventImport: {
        id: 'eventImport',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventCreate: {
        id: 'eventCreate',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [
          storage.eventMainImage,
          storage.eventOrganizerLogo,
          storage.eventResources,
          storage.eventSponsorLogo,
          storage.eventCallToActionLogo,
          storage.eventDailyCoverageSponsorLogo,
        ],
      },
      eventEdit: {
        id: 'eventEdit',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [
          storage.eventMainImage,
          storage.eventOrganizerLogo,
          storage.eventResources,
          storage.eventSponsorLogo,
          storage.eventCallToActionLogo,
          storage.eventDailyCoverageSponsorLogo,
        ],
      },
      eventVisibilityEdit: {
        id: 'eventVisibilityEdit',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventCopyToTenants: {
        id: 'eventCopyToTenants',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventDestroy: {
        id: 'eventDestroy',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [
          storage.eventMainImage,
          storage.eventOrganizerLogo,
          storage.eventResources,
          storage.eventSponsorLogo,
          storage.eventCallToActionLogo,
          storage.eventDailyCoverageSponsorLogo,
        ],
      },
      eventRead: {
        id: 'eventRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventAutocomplete: {
        id: 'eventAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventPublish: {
        id: 'eventPublish',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventClone: {
        id: 'eventClone',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },

      tagImport: {
        id: 'tagImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      tagCreate: {
        id: 'tagCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      tagEdit: {
        id: 'tagEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      tagDestroy: {
        id: 'tagDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      tagRead: {
        id: 'tagRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      tagAutocomplete: {
        id: 'tagAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },

      categoryImport: {
        id: 'categoryImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      categoryCreate: {
        id: 'categoryCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      categoryEdit: {
        id: 'categoryEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      categoryDestroy: {
        id: 'categoryDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      categoryRead: {
        id: 'categoryRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      categoryAutocomplete: {
        id: 'categoryAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },

      eventClassImport: {
        id: 'eventClassImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventClassCreate: {
        id: 'eventClassCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventClassEdit: {
        id: 'eventClassEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventClassDestroy: {
        id: 'eventClassDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventClassRead: {
        id: 'eventClassRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventClassAutocomplete: {
        id: 'eventClassAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventTimeZoneImport: {
        id: 'eventTimeZoneImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventTimeZoneCreate: {
        id: 'eventTimeZoneCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventTimeZoneEdit: {
        id: 'eventTimeZoneEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventTimeZoneDestroy: {
        id: 'eventTimeZoneDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventTimeZoneRead: {
        id: 'eventTimeZoneRead',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventTimeZoneAutocomplete: {
        id: 'eventTimeZoneAutocomplete',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryImport: {
        id: 'countryImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryCreate: {
        id: 'countryCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryEdit: {
        id: 'countryEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryDestroy: {
        id: 'countryDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryRead: {
        id: 'countryRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryAutocomplete: {
        id: 'countryAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },

      placeImport: {
        id: 'placeImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      placeCreate: {
        id: 'placeCreate',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      placeEdit: {
        id: 'placeEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      placeDestroy: {
        id: 'placeDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      placeRead: {
        id: 'placeRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      placeAutocomplete: {
        id: 'placeAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      placeMerge: {
        id: 'placeMerge',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventScheduleImport: {
        id: 'eventScheduleImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventScheduleCreate: {
        id: 'eventScheduleCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventScheduleEdit: {
        id: 'eventScheduleEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventScheduleDestroy: {
        id: 'eventScheduleDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      eventScheduleRead: {
        id: 'eventScheduleRead',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      eventScheduleAutocomplete: {
        id: 'eventScheduleAutocomplete',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      contactImport: {
        id: 'emaiCImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      contactCreate: {
        id: 'contactCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      contactEdit: {
        id: 'contactEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      contactDestroy: {
        id: 'contactDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      contactRead: {
        id: 'contactRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      contactAutocomplete: {
        id: 'contactAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      positionImport: {
        id: 'positionImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      positionCreate: {
        id: 'positionCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      positionEdit: {
        id: 'positionEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      positionDestroy: {
        id: 'positionDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      positionRead: {
        id: 'positionRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      positionAutocomplete: {
        id: 'positionAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryStateImport: {
        id: 'countryStateImport',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryStateCreate: {
        id: 'countryStateCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryStateEdit: {
        id: 'countryStateEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryStateDestroy: {
        id: 'countryStateDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
        allowedStorage: [

        ],
      },
      countryStateRead: {
        id: 'countryStateRead',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
      countryStateAutocomplete: {
        id: 'countryStateAutocomplete',
        allowedRoles: [roles.admin, roles.local],
        allowedPlans: [plans.free, plans.growth, plans.enterprise],
      },
    };
  }

  static get asArray() {
    return Object.keys(this.values).map((value) => {
      return this.values[value];
    });
  }
}

export default Permissions;
